export default __webpack_public_path__ + "static/park-title-1754dbcc4c250188d8ee7b032b55844b.png";